import React from "react";
import Hero from "../../components/hero";
import Layout from "../../components/Layout/Page";
import {
  DescriptionContainer,
  Description,
  CardsContainer,
  Card,
  Title,
  CardDescription,
} from "./styled.components";
import data from "./config";
const Groups = () => {
  return (
    <Layout>
      <Hero
        title="3H & Groups"
        SubTitle="HHH and Sons Presents a Proud Past And Will Keep The Promise For Days To Come"
      />
      <DescriptionContainer>
        <Description>
          Its been a great saga of growth and expansion in a short span of time
          for Haji Hamid Hussain & Sons the incredible achievements have been
          made through numerous companies to flourish under the vast HHH Canopy.
          HHH been the leader in the construction industry since five dacades.
          Our role in the construction industry stand onwords from the Great
          valley's of Gilgit Baltistan to the different regions of Pakistan.
        </Description>
      </DescriptionContainer>
      <CardsContainer>
        {data.map((item) => (
          <Card>
            <Title> {item.title}</Title>
            <CardDescription> {item.Description} </CardDescription>
          </Card>
        ))}
      </CardsContainer>
    </Layout>
  );
};

export default Groups;
